// Snackbar durations by variant
export const SNACKBAR_DURATIONS = {
  success: 3000,
  error: 8000,
  warning: 5000,
  info: 5000,
  default: 5000
} as const;

export const iconStyle = {
  marginRight: 8
};
